import { makeStyles } from 'tss-react/mui';
import ReactMarkdown from 'react-markdown';
import { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown';
import { CSSProperties } from 'react';


const useStyles = makeStyles({ name: 'markdown-overrides' })(theme => ({
  root: {
    '& h1': { ...theme.typography.h1 as CSSProperties },
    '& h2': { ...theme.typography.h2 as CSSProperties },
    '& h3': { ...theme.typography.h3 as CSSProperties },
    '& h4': { ...theme.typography.h4 as CSSProperties },
    '& h5': { ...theme.typography.h5 as CSSProperties },
    '& h6': { ...theme.typography.h6 as CSSProperties },
    '& p': { ...theme.typography.body1 as CSSProperties },
    '& strong': {
      ...theme.typography.body1 as CSSProperties,
      fontWeight: 600,
    },
  }
}));

export type MarkdownProps = {
  children: string;
  skipHtml?: boolean;
  components?: ReactMarkdownOptions['components'];
};

export const Markdown: React.FC<MarkdownProps> = ({ skipHtml, children, components }) => {
  const { classes } = useStyles();

  return (
    <ReactMarkdown className={classes.root} components={components} skipHtml={skipHtml}>
      {children}
    </ReactMarkdown>
  );
};
